// extracted by mini-css-extract-plugin
module.exports = {"blockWrapper":"Videos-module--blockWrapper--3a0or","textWrapper":"Videos-module--textWrapper--1d2-Z"};